import { render, staticRenderFns } from "./paymentComponent.vue?vue&type=template&id=232e6f8f"
import script from "./paymentComponent.vue?vue&type=script&lang=js"
export * from "./paymentComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports